/**
 * Poly Hydration — Error Fallback
 *
 * Provides the error fallback UI rendered into block containers when hydration
 * fails and no recoverable DOM snapshot is available.
 */

import { DEBUG } from './config';

/**
 * Renders a standardized error fallback UI into a block container.
 *
 * In DEBUG mode, shows a visible error banner so developers notice the failure.
 * In production, clears the block silently — a blank space is preferable to a
 * jarring error message for end users.
 */
export function renderErrorFallback(block: Element): void {
  if (DEBUG) {
    block.innerHTML = '<div style="padding: 20px; background: #fff5f5; border: 1px solid #ff7a7a; border-radius: 8px; color: #db0000;">Component failed to load</div>';
  } else {
    block.innerHTML = '';
  }
}

/**
 * Restores a block container's DOM from a previously-captured snapshot.
 *
 * Clones the snapshot before restoring so the original snapshot remains
 * intact and reusable. Replaces the current (potentially corrupted) children
 * with the cloned nodes, preserving the server-rendered visual state.
 */
export function restoreSnapshot(block: Element, snapshot: Node): void {
  block.innerHTML = '';
  const clone = snapshot.cloneNode(true);
  while (clone.firstChild) {
    block.appendChild(clone.firstChild);
  }
}
